export default __webpack_public_path__ + "static/media/The Crescent of Blood.9882b5c7.jpg";